import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SecurityControlCardRequestService } from "../../../../../services/company-office/SecurityControlCardService";
import { useSelector } from "../../../../../store/store";
import { getEnv } from "../../../../../AppConfigs";
import { mailRegexs } from "../../../../../constants/mailTemplateConstants";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { MailService } from "../../../../../services/mail/mail.service";
import { Routes } from "../../../../../AppRoutes";
const siteUrl = getEnv("REACT_APP_APPROVER_SECURITY_CONTROL_CARD_REQUEST_URL");

export const useCloneSecurityControlMutation = () => {
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const queryCLient = useQueryClient();
  const history = useHistory();

  const sendMail = async (approver: any, eprCodeRequest: any) => {
    const url = siteUrl + "/details/" + eprCodeRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "SCTRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", eprCodeRequest.createdBy.user.displayName)
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(eprCodeRequest.createdDateTime)} - ${getHHmmFormat(eprCodeRequest.createdDateTime)}`,
      )
      .replace(mailRegexs.siteUrl, url);

    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const mutation = useMutation({
    mutationFn: async (data: any) => {
      const request = {
        fields: {
          Title: `Cấp thẻ kiểm soát an ninh cho nội bộ VIAGS`,
          eApprovedBy: data?.eApprovedBy,
          eSoftwareId: data?.eSoftwareId,
          eApprovedByITLead: data?.eApprovedByITLead,
          eApprovedByITHead: data?.eApprovedByITHead,
          eAssignee: data?.eAssignee,
          eRequestStatus: data?.eRequestStatus,
          eRequestType: data?.eRequestType,
          eStage: data?.eStage,
          eSuggestion: data?.eSuggestion,
          eContent: data?.eContent,
          eFileContent: data?.eFileContent,
          eDepartment: data?.eDepartment,
          eUnit: data?.eUnit,
          ePhoneNumber: data?.ePhoneNumber,
          eBaseId: data?.eBaseId,
          ePurpose: data?.ePurpose,
          eDeadline: data?.eDeadline,
          eArea: data?.eArea,
          // eDocumentary: documentary.length > 0 ? JSON.stringify(documentary) : null,
          eDocumentAttach: data?.eDocumentAttach,
          eAviationSecurityCertification: data?.eAviationSecurityCertification,
          isAutoRenew: data?.isAutoRenew,
        },
      };

      return await SecurityControlCardRequestService.addSecurityControlCardRequest(request);
    },
  });

  const cloneRequest = (data: any) =>
    mutation.mutate(data, {
      onSuccess(res) {
        if (res.fields.eApprovedBy) {
          sendMail(res.fields.eApprovedBy, res);
        }
        queryCLient.invalidateQueries({ queryKey: ["security-control-card-requests"] });
        history.push(Routes.detailSercurityCardUnitsPage.path.replace(":id", res.id));
      },
    });

  return { cloneRequest };
};
